import { MenuItemInfo } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

import { textCellPadding } from '../dataConnectMultiCluster/DataConnectMultiClusterTableHeaders';
import { ActionItemInfo, ActionItemType, ActionType, MoreActionsMenu } from '../MoreActionsMenu';
import { Domain } from '../types/Domain';
import { DomainType } from '../types/DomainType';
import { PoolID } from '../types/PoolID';
import { UserDefinedPoolModel } from '../types/PoolModel';
import { openDeletePoolDomainDialog } from './deleteDomainConfirmationDialog/DeleteDomainConfirmationDialog';
import { openEditPoolDomainDialog } from './editDomainDialog/EditDomainDialog';
import { openMovePoolDomainDialog } from './moveDomainDialog/MoveDomainDialog';


export type DataConnectPoolDomainsTableRowProps = Readonly<{
  domain: Domain;
  index: number;
  poolId: PoolID;
  poolName: string;
  userDefinedPools: Record<string, UserDefinedPoolModel>;
  bridgeDomains: Record<string, Domain>;
  poolTestId: string;
  refreshPoolsAndClusters: () => void;
}>;


export function DataConnectPoolDomainsTableRow(props: DataConnectPoolDomainsTableRowProps) {
  const {   index, poolId, poolName, poolTestId, domain , userDefinedPools, bridgeDomains, refreshPoolsAndClusters } = props;
  const cellClass =  textCellPadding + ' tb-data-grid-separator-row';

  const targetSelectItem: MenuItemInfo[] = [
    { displayValue: domain.domainType === DomainType.FILESERVER ? Messages.dataConnectSiteSettingsEditDomainFileServerButton() : Messages.dataConnectSiteSettingsEditDomainButton(),
      value: ActionType.EDIT_POOL_DOMAIN},
  ];
  if (domain.domainType !== DomainType.FILESERVER) {
    targetSelectItem.push({ displayValue: Messages.dataConnectSiteSettingsMoveDomainButton(), value: ActionType.MOVE_POOL_DOMAIN});
  }

  targetSelectItem.push({ displayValue: Messages.deleteMessage(), value: ActionType.DELETE_POOL_DOMAIN});
  return <>
    <td className={cellClass} style={{paddingLeft: 3}}>
      <span className={'tb-data-grid-cell-text-data-connect tb-lr-padded-wide'} data-tb-test-id={'domain-name-cell' + poolTestId}>
        {domain.domainType === DomainType.FILESERVER ? domain.fileServerPath : domain.domainName}
      </span>
    </td>
    <td className={cellClass} style={{paddingLeft: 12}}>
      <span className={'tb-data-grid-cell-text-data-connect tb-lr-padded-wide'} data-tb-test-id={'domain-type-cell' + poolTestId}>
        {domain.domainType === DomainType.FILESERVER ? Messages.dataConnectSiteSettingsDomainFileServerListType() : Messages.dataConnectSiteSettingsDomain()}
      </span>
    </td>
    <td className={cellClass} style={{paddingLeft: 12}}>
      <span className={'tb-data-grid-cell-text-data-connect tb-lr-padded-wide'} data-tb-test-id={'domain-domainPermission-cell' + poolTestId}>
        {Messages.dataConnectSiteSettingsDomainAccessAllow()}
      </span>
    </td>
    <td className={cellClass} style={{paddingLeft: 15}}>
      <span className={'tb-data-grid-cell-text-data-connect tb-lr-padded-wide'} data-tb-test-id={'domain-actions-cell' + poolTestId}>
        <MoreActionsMenu
          targetItemInfo={targetSelectItem}
          actionType= {ActionItemType.NODE_ACTION}
          actionItemInfo={{poolId: poolId, poolName: poolName,
                      domain: domain, userDefinedPools: userDefinedPools,
                      bridgeDomains: bridgeDomains,
                      domainType: domain.domainType,
                      filePath: domain.fileServerPath,
                      refreshPoolsAndClusters: refreshPoolsAndClusters }}
          onHandleMenuSelect={onHandleMenuSelect}
        />
       </span>
    </td>
  </>;
}


const onHandleMenuSelect = (actionItem: ActionItemInfo, actionType: string) => {
    if (actionType === ActionType.EDIT_POOL_DOMAIN) {
      openEditPoolDomainDialog(actionItem);
    } else if (actionType === ActionType.DELETE_POOL_DOMAIN) {
      openDeletePoolDomainDialog(actionItem);
    } else if (actionType === ActionType.MOVE_POOL_DOMAIN) {
      openMovePoolDomainDialog(actionItem);
    }

};
